export default __webpack_public_path__ + "media/images/front/footer/traveler-b4d632cd130ef69e18afd1b6d74ebfa4.png";